module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Bold.815f2b7639c3121da7d3279bed35ba66.eot";